import { useGetVisitsHistoryQuery } from '@/queries/useGetVisitsHistoryQuery';

export const useVisitsHistory = () => {
  const { data: visitsHistoryData, isLoading } = useGetVisitsHistoryQuery();

  if (isLoading) {
    return { visitsHistoryData: [], isLoading };
  }

  return { visitsHistoryData };
};
